export default __webpack_public_path__ + "static/media/banner.bfeb8f18.png";